// src/components/questionnaire/ProgressIndicator.jsx
import React from 'react';

const ProgressIndicator = ({ currentIndex, totalQuestions }) => {
  const progressPercentage = Math.round(((currentIndex + 1) / totalQuestions) * 100);

  return (
    <div className="mb-8">
      <div className="flex justify-between text-sm text-gray-600">
        <span>Question {currentIndex + 1} of {totalQuestions}</span>
        <span>{progressPercentage}% Complete</span>
      </div>
      <div className="mt-2 h-2 bg-gray-200 rounded-full">
        <div
          className="h-full bg-blue-600 rounded-full transition-all duration-300"
          style={{ width: `${progressPercentage}%` }}
        />
      </div>
    </div>
  );
};

export default ProgressIndicator;